"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/PlaceIcon.tsx
var PlaceIcon_exports = {};
__export(PlaceIcon_exports, {
  default: () => PlaceIcon_default
});
module.exports = __toCommonJS(PlaceIcon_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var PlaceIcon = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20.48 20.48",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M10.24 10.24a3.84 3.84 0 1 0 0 -7.68 3.84 3.84 0 0 0 0 7.68m0 1.28a5.12 5.12 0 1 1 0 -10.24 5.12 5.12 0 0 1 0 10.24"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M10.24 10.24a0.64 0.64 0 0 1 0.64 0.64v5.12a0.64 0.64 0 1 1 -1.28 0V10.88a0.64 0.64 0 0 1 0.64 -0.64"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          fill: "currentColor",
          d: "M7.68 12.982v1.299C5.395 14.647 3.84 15.438 3.84 16c0 0.754 2.798 1.92 6.4 1.92s6.4 -1.166 6.4 -1.92c0 -0.563 -1.555 -1.353 -3.84 -1.719v-1.299C15.782 13.421 17.92 14.607 17.92 16c0 1.766 -3.438 3.2 -7.68 3.2s-7.68 -1.434 -7.68 -3.2c0 -1.394 2.138 -2.579 5.12 -3.018"
        }
      )
    ]
  }
);
var PlaceIcon_default = PlaceIcon;
